import React from "react"
import slack from "../assets/add-to-slack.png"
import "./Login.css"

class Login extends React.Component {
  render() {
    return (
      <div
        style={{
          width: "100vw",
          paddingTop: 100,
          margin: "0 auto",
          textAlign: "center"
        }}
      >
        <h1 style={{ fontWeight: 100 }}>Login with Slack</h1>
        <p style={{ marginTop: -10 }}>
          You'll get redirected back here to your dashboard.
        </p>
        <a
          href="https://slack.com/oauth/authorize?scope=files:read,channels:write,groups:write,bot,commands,chat:write:bot,users:read,team:read&client_id=73100902978.130145105494"
          style={{ display: "block", marginTop: 20 }}
        >
          <img
            alt="Add to Slack"
            src={slack}
            className="Login_addSlack"
            style={{ height: 50 }}
          />
        </a>
        <p style={{ maxWidth: 360, margin: "30px auto 0" }}>
          By clicking “Add to Slack” you agree to the Smallchat{" "}
          <a href="https://small.chat/terms" target="_blank">
            Privacy Policy & Terms of Service
          </a>.
        </p>
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/auth/Login.js